<template>
    <Drawer
        :title="title"
        v-model="isBox"
        width="540"
        :mask-closable="false"
        @on-close="FormReset()"
        class-name="drawer-default"
    >
        <div class="set-scroll-form">
            <Form ref="Forms" :model="Forms" :rules="Rules" label-position="top">
                <Row>
                    <Col span="24">
                        <FormItem label="登录账号：" prop="username">
                            <Input v-model="Forms.username" placeholder="建议手机号" />
                        </FormItem>
                    </Col>
                    <Col span="24">
                        <FormItem label="所属角色：" prop="group_id">
                            <Select v-model="Forms.group_id" filterable clearable placeholder="角色" >
                                <Option v-for="(item,index) in groupList" :value="item.group_id" :key="index">{{ item.name }}</Option>
                            </Select>
                        </FormItem>
                    </Col>
                    <Col span="24">
                        <FormItem label="登录密码：" prop="password">
                            <Input v-model="Forms.password" :placeholder="!Forms.admin_id?'默认密码:123456':'填写则修改密码'" />
                        </FormItem>
                    </Col>
                    <Col span="24">
                        <FormItem label="姓名：" prop="real_name">
                            <Input v-model="Forms.real_name" placeholder="必填" />
                        </FormItem>
                    </Col>
                    <Col span="24">
                        <FormItem label="手机号码：" prop="mobile">
                            <Input v-model="Forms.mobile" placeholder="必填" />
                        </FormItem>
                    </Col>
                    <Col span="24">
                        <FormItem label="微信号：" prop="wechat">
                            <Input v-model="Forms.wechat" placeholder="非必填" />
                        </FormItem>
                    </Col>
                    <Col span="24">
                        <FormItem label="电子邮箱：" prop="email">
                            <Input v-model="Forms.email" placeholder="非必填" />
                        </FormItem>
                    </Col>
                    <Col span="24">
                        <FormItem label="账户状态：">
                            <RadioGroup v-model="Forms.status" type="button">
                                <Radio :label="1">审核</Radio>
                                <Radio :label="2">禁用</Radio>
                                <Radio :label="3">开启</Radio>
                            </RadioGroup>
                        </FormItem>
                    </Col>
                </Row>
            </Form>
            <div class="box-drawer-footer">
                <Button style="margin-right: 8px" @click="FormReset()">取消</Button>
                <Button type="primary" :loading="$store.state.loading" @click="FormSubmit()">保存</Button>
            </div>
        </div>
    </Drawer>
</template>

<script>

import {getSelectList} from "@/apis/group";
import {saveAdmin, getAdminDetail} from "@/apis/framework";

export default {
    name: 'Create',
    components: {
    },
    emits: ['trueHandler'],
    data () {
        return {
            title : '新增成员',
            isBox : false,
            groupList : [],
            Forms : {
                admin_id:'',
                username: '',
                group_id: 0,
                password: '',
                real_name: '',
                mobile: '',
                wechat: '',
                email: '',
                status: 3
            },
            Rules : {
                username: [
                    { required: true, message: '请输入登录账号', trigger: 'blur' },
                    { type: 'string', min: 5, message: '用户名不能少于6个字符', trigger: 'blur' }
                ],
                group_id: [
                    { required: true, type: 'number',  message: '请选择所属角色', trigger: 'change',  transform(value) { return parseInt(value)}  },
                    { type: 'number', min: 1, message: '请选择所属角色', trigger: 'change', transform(value) { return parseInt(value)} }
                ],
                password: [
                    { type: 'string', min: 6, message: '密码不能少于6个字符', trigger: 'blur' }
                ],
                real_name: [
                    { required: true, message: '请填写姓名', trigger: 'blur' },
                ],
                mobile: [
                    { required: true, message: '请填写手机号码', trigger: 'blur' },
                ]
            }
        }
    },
    methods: {
        /**
         功能：获取详情
         time: 2025-53-02 10:53:04
         **/
        GetDetail(admin_id){
            let that = this;
            that.$store.commit('SET_LOADING' , true);
            getAdminDetail(admin_id).then(e => {
                let data = e.data;
                for (let v of Object.keys(that.Forms)) {
                    if(v === 'group_id' || v === 'status'){
                        that.Forms[v] = parseInt(data[v]);
                    }else{
                        that.Forms[v] = data[v];
                    }
                }
            })
        },
        /**
         功能：
         time: 2025-49-03 11:49:48
         **/
        GetGroupList(){
            let that = this;
            getSelectList().then(e=>{
                that.groupList = e.data;
            })
        },
        /**
         功能：添加
         time: 2025-52-02 10:52:34
         **/
        add(){
            this.isBox = true;
            this.GetGroupList();
        },
        /**
         功能：编辑
         time: 2025-52-02 10:52:42
         **/
        edit(admin_id){
            this.isBox = true;
            this.title = '编辑成员';
            this.GetGroupList();
            if(admin_id) this.GetDetail(admin_id);
        },
        /**
         功能：
         time: 2025-55-02 10:55:40
         **/
        FormSubmit(){
            let that = this;
            this.$refs['Forms'].validate((valid) => {
                if (valid) {
                    that.$store.commit('SET_LOADING' , true);
                    saveAdmin(that.Forms).then( e =>{
                        that.$Message.success({ background: true,duration:3, content: e.msg });
                        that.FormReset();
                        that.$emit('trueHandler');
                    })
                }
            })
        },
        /**
         功能：
         time: 2025-55-02 10:55:45
         **/
        FormReset(){
            this.isBox = false;
            this.title = '新增成员';
            this.$refs['Forms'].resetFields();
            this.Forms.admin_id = '';
        }
    }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped lang="less" rel="stylesheet/less">
.forms {
    .ivu-form-item {
        //margin-bottom: 0 !important;
    }
}
.spin-icon-load{
    animation: ani-demo-spin 1s linear infinite;
}
@keyframes ani-demo-spin {
    from { transform: rotate(0deg);}
    50%  { transform: rotate(180deg);}
    to   { transform: rotate(360deg);}
}
.spin-text {
    font-size: 12px;
    padding-top: 10px;
}
</style>
